import { ScreenerSettingName } from '@/hooks/screener-settings';
import { useScreenerSettingsQuery } from '@/pages/CRM/Screener/hooks/useScreenerSettingsQuery';
import { ExacareFeature, FeatureFlagService } from '@/utils/featureFlagService';

interface UseCrmEsignAvailabilityOptions {
  enabled?: boolean;
}

export function useCrmEsignAvailability(
  options: UseCrmEsignAvailabilityOptions = {}
) {
  const featureFlagEnabled = FeatureFlagService.isEnabled(
    ExacareFeature.CRM_ESIGN
  );
  const queryEnabled = (options.enabled ?? true) && featureFlagEnabled;
  const { useFindOne } = useScreenerSettingsQuery();
  const orgEnabledQuery = useFindOne(
    {
      settingName: ScreenerSettingName.EsignEnabled
    },
    {
      enabled: queryEnabled
    }
  );

  return {
    isEnabled: queryEnabled && orgEnabledQuery.data?.data?.value === 'enabled',
    isLoading: queryEnabled && orgEnabledQuery.isLoading
  };
}
